import { motion } from "framer-motion";
import { Star } from "lucide-react";
import { TESTIMONIALS } from "@/data/content";
import { easeOutExpo, fadeUp } from "@/lib/motion";

export default function Testimonials() {
  return (
    <section className="py-16 md:py-24 lg:py-28" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16">
        <motion.div {...fadeUp} className="max-w-2xl">
          <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-crimson" data-testid="testimonials-eyebrow">
            Voices of Joy
          </p>
          <h2 className="mt-4 font-display text-4xl sm:text-5xl lg:text-6xl font-semibold tracking-tight text-charcoal" data-testid="testimonials-heading">
            Wrapped, sent, <span className="italic text-terracotta">loved</span>
          </h2>
        </motion.div>

        <div className="mt-12 grid md:grid-cols-3 gap-7">
          {TESTIMONIALS.map((t, i) => (
            <motion.figure
              key={t.name}
              {...fadeUp}
              transition={{ ...fadeUp.transition, delay: 0.09 * i }}
              className="relative rounded-2xl bg-ivory border border-gold/25 p-7 shadow-[0_25px_60px_-35px_rgba(26,21,18,0.35)] hover:-translate-y-1 transition-transform duration-400"
              data-testid={`testimonial-card-${i + 1}`}
            >
              <span className="absolute -top-4 left-6 font-display text-7xl text-gold/40 leading-none select-none" aria-hidden="true">
                ”
              </span>
              <div className="flex gap-1 pt-2" data-testid={`testimonial-stars-${i + 1}`}>
                {Array.from({ length: 5 }).map((_, s) => (
                  <Star key={s} className="h-4 w-4 fill-gold text-gold" />
                ))}
              </div>
              <blockquote className="mt-4 text-[15px] leading-relaxed text-charcoal/85">
                {t.quote}
              </blockquote>
              <figcaption className="mt-6 border-t border-gold/20 pt-4">
                <p className="font-display text-lg font-semibold text-charcoal">{t.name}</p>
                <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-terracotta mt-1">{t.meta}</p>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
